module.exports = __webpack_public_path__ + "img/money.a45d0fb9.svg";